import type { IAuthUser } from './AuthClient';
import type { IAuthState } from './AuthState';

type IAction =
  | { type: 'LOGIN_STARTED' }
  | {
      type: 'INITIALIZED' | 'LOGIN_COMPLETE';
      user?: IAuthUser;
    }
  | { type: 'LOGOUT_STARTED' }
  | { type: 'LOGOUT_COMPLETE' }
  | { type: 'LOGIN_ERROR'; error?: Error }
  | { type: 'LOGOUT_ERROR'; error?: Error };

/**
 * Handles how that state changes in the `useAuth` hook.
 */
export const reducer = (state: IAuthState, action: IAction): IAuthState => {
  switch (action.type) {
    case 'LOGIN_STARTED':
      return {
        ...state,
        isLogingIn: true,
        isLogingOut: false,
      };

    case 'INITIALIZED':
    case 'LOGIN_COMPLETE':
      return {
        ...state,
        isAuthenticated: !!action.user,
        user: action.user,
        isLogingIn: false,
        isLogingOut: false,
        error: undefined,
      };

    case 'LOGOUT_STARTED':
      return {
        ...state,
        isLogingIn: false,
        isLogingOut: true,
      };

    case 'LOGOUT_COMPLETE':
      return {
        ...state,
        isAuthenticated: false,
        user: undefined,
        isLogingIn: false,
        isLogingOut: false,
        error: undefined,
      };

    case 'LOGIN_ERROR':
      return {
        ...state,
        isAuthenticated: false,
        user: undefined,
        isLogingIn: false,
        isLogingOut: false,
        error: action.error,
      };

    case 'LOGOUT_ERROR':
      return {
        ...state,
        isAuthenticated: false,
        user: undefined,
        isLogingIn: false,
        isLogingOut: false,
        error: action.error,
      };
  }
};
